export const CLIENT_SCOPES = {
  SYSTEM: "system",
  TENANT: "tenant",
};

export const DEFAULT_GRANT_TYPES = ["password"];

export const GRANT_TYPE_OPTIONS = [
  "password",
  "authorization_code",
  "access_handover",
  "client_credentials",
  "refresh_token",
];
